import { http } from '../util/http';

export default class HomeBannerService {
	static getAll() {
		return http.get(`/home-banner`);
	}

	static getActive() {
		return http.get(`/home-banner/active`);
	}

	static add(body) {
		return http.post('/home-banner', body);
	}

	static update(id, body) {
		return http.patch(`/home-banner/${id}`, body);
	}

	static updateStatus(id, body) {
		return http.patch(`/home-banner/${id}/status`, body);
	}

	static updateMobileImage(id, body) {
		return http.patch(`/home-banner/${id}/mobile`, body);
	}

	static updateWebImage(id, body) {
		return http.patch(`/home-banner/${id}/web`, body);
	}

	static delete(id) {
		return http.delete(`/home-banner/${id}`);
	}
}
